import { useEffect, useRef, useState } from 'react';
import type { TenantSettingsRoutePort } from '../port/TenantSettingsPort';
import type { TenantSettingsRootPage, TenantSettingsRoute, TenantSettingsView } from './types';
export function useTenantSettingsRoute(root: TenantSettingsRootPage, port: TenantSettingsRoutePort) {
  const [current, setCurrent] = useState<TenantSettingsRoute>(() => port.read(root));
  const titleRef = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    const apply = () => {
      const next = port.read(root);
      if (!next.canonical)
        port.navigate(next.root, next.view, next.companyId, {
          replace: true,
        });
      setCurrent(next);
    };
    apply();
    return port.subscribe(apply);
  }, [port, root]);
  useEffect(() => {
    titleRef.current?.focus({
      preventScroll: true,
    });
  }, [current.companyId, current.view]);
  const navigate = (view: TenantSettingsView, companyId = '') => port.navigate(root, view, companyId);
  return {
    ...current,
    navigate,
    titleRef,
  };
}
